import Button from '../button/Button';

import { PageTitleProps } from './type';

const PageTitle = (props: PageTitleProps) => {
  const {
    title,
    description,
    primaryButtonLabel,
    primaryButtonIcon,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    secondaryButtonLabel,
    primaryButtonIconStyle,
    primaryButtonStroke,
    className,
    isPrimaryButtonDisabled,
    isPrimaryButtonLoading,
    secondaryButtonIcon,
    secondaryButtonIconStyle,
    secondaryButtonStroke,
    customDescriptionStyle,
    secondaryButtonClassName
  } = props;
  return (
    <div className={`flex items-center justify-between ${className || ''}`}>
      <div className="flex items-center">
        <h1 className="text-2xl font-semibold text-content mobile:text-lg">
          {title}
        </h1>
        <div
          className={`mt-2 text-sm font-normal text-grey10 ${customDescriptionStyle}`}
        >
          {description}
        </div>
      </div>
      <div className="flex items-center gap-4">
        {secondaryButtonLabel && (
          <Button
            label={secondaryButtonLabel}
            handleClick={onSecondaryButtonClick}
            variant="secondary"
            size="medium"
            rightIconName={secondaryButtonIcon}
            rightIconStyle={secondaryButtonIconStyle}
            rightIconStroke={secondaryButtonStroke || ''}
            className={secondaryButtonClassName || ''}
          />
        )}
        {primaryButtonLabel && (
          <Button
            label={primaryButtonLabel}
            handleClick={onPrimaryButtonClick}
            variant="primary"
            size="medium"
            rightIconName={primaryButtonIcon}
            rightIconStyle={primaryButtonIconStyle}
            rightIconStroke={primaryButtonStroke || ''}
            disabled={isPrimaryButtonDisabled || false}
            loading={isPrimaryButtonLoading || false}
          />
        )}
      </div>
    </div>
  );
};

export default PageTitle;
